<template>
  <div>
  <el-dialog :title="titleName"
             :visible.sync="dialogFormVisible"
             width="55%"
             class="usereditcss"
  >
    <el-form :model="form" style="text-align: center" :rules="rules" ref="ruleForm">
      <el-row>
        <el-col :span="12">
          <el-form-item label="用户账号" :label-width="formLabelWidth" :required="true" prop="username">
            <el-input v-model="form.username" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="用户密码" :label-width="formLabelWidth" :required="!passwordDisabled" prop="password">
            <el-input type="password" v-model="form.password" autocomplete="off" :disabled="passwordDisabled"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="真实姓名" :label-width="formLabelWidth" :required="true" prop="name">
            <el-input v-model="form.name" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="手机号码" :label-width="formLabelWidth" :required="true" prop="mobile">
            <el-input v-model="form.mobile" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="所属部门" :label-width="formLabelWidth" :required="true" prop="deptName">
            <el-input v-model="form.deptName" v-on:click.native="selectDept" autocomplete="off" :readonly="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="用户邮件" :label-width="formLabelWidth">
            <el-input v-model="form.email" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12" style="height: 36px;text-align: left">
          <el-form-item label="有效状态" :label-width="formLabelWidth" :required="true" prop="status">
            <el-radio v-model="form.status" :label="1">正常</el-radio>
            <el-radio v-model="form.status" :label="0">禁用</el-radio>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24" style="height: 36px;text-align: left">
          <el-form-item label="选择角色" :label-width="formLabelWidth">
            <el-checkbox-group v-model="form.roleIds">
                <el-checkbox v-for="role in roles" :label="role.roleId" :key="role.roleId">{{role.roleName}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
      </el-row>

    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="mini" @click="dialogFormVisible = false">取 消</el-button>
      <el-button size="mini" type="primary" @click="addAndUpdate('ruleForm')">确 定</el-button>
    </div>

  </el-dialog>
    <deptTree v-if="deptTreeVisible" ref="deptTree" @handleSelectDept="handleSelectDept"></deptTree>
  </div>
</template>

<script>
  import DeptTree from './deptTree'
  export default {
    name: 'DeptTreeDoalog',
    components:{
      DeptTree
    },
    data() {
      return {
        dialogFormVisible: true,
        deptTreeVisible: false,
        passwordDisabled: true,
        roles:[],
        url: '',
        titleName: '',
        form: {
          userId: '',
          username: '',
          password: '',
          name: '',
          deptId: '',
          deptName: '',
          email: '',
          status: 1,
          userIdCreate: '',
          sex: '',
          mobile: '',
          birth: '',
          roleIds:[]
        },
        rules: {
          username: [{required: true, message: '请输入用户账号', trigger: 'blur'}],
          password: [{required: true, message: '请输入用户密码', trigger: 'blur'}],
          name: [{required: true, message: '请输真实姓名', trigger: 'blur'}],
          mobile: [{required: true, message: '请输入手机号码', trigger: 'blur'}],
          deptName: [{required: true, message: '请选择所属部门', trigger: 'blur'}],
          status: [{required: true, message: '请选择有效状态', trigger: 'blur'}]
        },
        formLabelWidth: '120px'
      };
    },
    methods: {
      int(id) {
        this.dialogFormVisible = true;

        this.form.userId = '';
        this.form.username = '';
        this.form.password = '';
        this.form.name = '';
        this.form.deptId = '';
        this.form.deptName = '';
        this.form.email = '';
        this.form.status = 1;
        this.form.userIdCreate = '';
        this.form.sex = '';
        this.form.mobile = '';
        this.form.birth = '';
        this.form.roleIds=[];
        this.$refs['ruleForm'].resetFields();

        if(id=='add'){
            this.titleName = "用户信息-新增";
            this.passwordDisabled = false;
            this.url = "/business/sys/user/save";
        }else{
          this.titleName = "用户信息-修改";
          this.passwordDisabled = true;
          this.rules.password[0].required = false;
          this.url = "/business/sys/user/update";

          this.$httpTAG({
            url: this.$httpTAG.adornUrl('/business/sys/user/view'),
            method: 'post',
            data: {userId:id}
          }).then(r => {
            this.form = r.data.data;
          }).finally(r => {})

        }
        this.getRoles()
      },
      getRoles(){
        this.$httpTAG({
          url: this.$httpTAG.adornUrl('/business/sys/user/getUserRole'),
          method: 'post'
        }).then(r => {
          this.roles  = r.data.data;
        }).finally(r => {})
      },
      handleSelectDept(deptId,deptName){
        this.form.deptId=deptId;
        this.form.deptName=deptName;
      },
      selectDept(){
        this.deptTreeVisible = true;
        this.$nextTick(()=>{
          this.$refs.deptTree.int();
        })
      },
      addAndUpdate(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$httpTAG({
              url: this.$httpTAG.adornUrl(this.url),
              method: 'post',
              data: this.$httpTAG.adornData(this.form)
            }).then(res => {
              if (res.data.code == 0) {
                this.$notify({
                  title: '操作成功！',
                  type: 'success',
                  offset: 600
                });
                this.dialogFormVisible = false
                this.$emit("handleCurrentChange",1);
              } else {
                this.$message({ // 失败
                  type: 'fail',
                  message: res.data.msg
                })
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }
    }
  };
</script>
<style scoped>
  .usereditcss >>> .el-dialog__body {
    padding: 30px 85px 45px 20px;
  }
</style>
